export const hasContent = block => Boolean(block.content);

export const handleGroupOnPlatform = group => group;

const EMOJI_REGEX =
  /([\u2000-\u32FF]|[\ud83c-\ud83e][\udc00-\udfff])(\u200d?([\u2000-\u32FF]|[\ud83c-\ud83e][\udc00-\udfff]))*/g;

export const titleFilter = value => (value ? value.replace(EMOJI_REGEX, '') : value);
